<template>
  <v-app>
    <UlHeader :has-border="!$vuetify.breakpoint.smAndDown" />
    <div class="header-end" />
    <v-main>
      <slot />
    </v-main>
    <ErrorModal />
    <BottomNavigation v-if="$vuetify.breakpoint.smAndDown" />
    <UnsupportedBrowserModal id="unsupported-browser-modal" />
    <UnavailableClinics />
    <AppLockOverlay v-if="$store.getters['appLock/isAppLockEnabled']" />
    <DeviceNotSecureOverlay />
  </v-app>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import profileLayoutSetup from '@/mixins/profileLayoutSetup';
import authUserWatcher from '@/mixins/authUserWatcher';
import UlHeader from '@/components/Organisms/UlHeader.vue';
import ErrorModal from '@/components/Atoms/ErrorModal.vue';
import BottomNavigation from '@/components/Molecules/BottomNavigation.vue';
import UnsupportedBrowserModal from '@/components/Atoms/UnsupportedBrowserModal.vue';
import AppLockOverlay from '@/feature/app-lock/components/AppLockOverlay.vue';
import DeviceNotSecureOverlay from '@/feature/app-lock/components/DeviceNotSecureOverlay.vue';
import UnavailableClinics from '@/components/Atoms/UnavailableClinics.vue';

export default {
  name: 'ProfileLock',
  components: {
    AppLockOverlay,
    DeviceNotSecureOverlay,
    UnavailableClinics,
    UnsupportedBrowserModal,
    BottomNavigation,
    ErrorModal,
    UlHeader
  },
  mixins: [profileLayoutSetup, authUserWatcher],
  metaInfo: {
    script: [
      {
        src: import.meta.env.MODE === 'production' ? '/linkedin-tracking-code.js' : '',
        body: true
      }
    ]
  },
  computed: {
    ...mapGetters({
      token: 'apiToken/token'
    })
  },
  beforeCreate() {
    this.$store.commit('general/setSendAuthorizationHeader', true);
    this.$store.commit('profile/bottomNavigation/setShowBottomNavigation', false);
    this.$graphql.appSettings.requestConfig.requestMiddleware = request =>
      this.graphqlRequestMiddleware(request);
    this.$graphql.appSettings.requestConfig.responseMiddleware = response =>
      this.graphqlResponseMiddleware(response);
  },
  beforeMount() {
    /* eslint-disable id-length */
    this.setWindowSize({ x: window.innerWidth, y: window.innerHeight });
    window.addEventListener(
      'resize',
      () => {
        this.setWindowSize({ x: window.innerWidth, y: window.innerHeight });
      },
      true
    );
    /* eslint-enable */

    if (this.$auth.user && this.$auth.user.language !== this.$i18n.locale) {
      this.$router.push(this.$switchLocalePath(this.$auth.user.language));
    }
  },
  mounted() {
    this.$store.commit('general/setHeaderSettings', {
      logoIsClickable: false,
      sticky: false,
      showMobileHeader: false,
      items: [
        {
          text: this.$t('profileSection.menu.logout'),
          buttonProps: {
            color: 'tetrary',
            text: false,
            class: 'error--text min-width-initial d-none d-md-block',
            clickAction: async () => {
              await this.logout('login');
            }
          }
        }
      ]
    });
  },
  destroyed() {
    this.$store.commit('profile/bottomNavigation/setShowBottomNavigation', true);
  },
  methods: {
    ...mapMutations({
      setWindowSize: 'general/setWindowSize'
    })
  }
};
</script>
